import React from 'react';
import ServerCard from './ServerCard';
import { ServerSummary } from '../types/server';
import { useLanguage } from '../contexts/LanguageContext';

interface ServerListProps {
  servers: ServerSummary[];
  title?: string;
  isLoading?: boolean;
  favoriteIds?: string[];
}

const ServerList: React.FC<ServerListProps> = ({ servers, title, isLoading = false, favoriteIds = [] }: ServerListProps) => {
  const { t } = useLanguage();

  return (
    <div>
      {title && <h3 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white text-center">{title}</h3>}
      {isLoading ? (
        <div className="bg-white dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 rounded-2xl p-12 text-center border border-gray-200 dark:border-gray-700 shadow-xl">
          <div className="text-gray-600 dark:text-gray-300">{t('server.list.loading')}</div>
        </div>
      ) : servers.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servers.map((server: ServerSummary) => (
            <ServerCard
              key={server.id}
              id={server.id}
              name={server.name}
              description={server.shortDescription || server.description}
              createdAt={server.createdAt}
              rating={server.ratingAverage}
              status={server.status}
              initialIsFavorite={favoriteIds.includes(server.id)}
              banner={server.bannerUrl}
              onlineRating={server.onlineRating}
              managementRating={server.managementRating}
              gameplayRating={server.gameplayRating}
            />
          ))}
        </div>
      ) : (
        <div className="bg-white dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 rounded-2xl p-12 text-center border border-gray-200 dark:border-gray-700 shadow-xl">
          <div className="text-5xl mb-4">🔍</div>
          <h3 className="text-2xl font-bold text-gray-700 dark:text-gray-300 mb-2">{t('server.list.empty_title')}</h3>
          <p className="text-gray-600 dark:text-gray-400">{t('server.list.empty_desc')}</p>
        </div>
      )}
    </div>
  );
};

export default ServerList;